import { Grid } from '@mui/material'
import { Box } from '@mui/system'
import { Link, useHistory } from 'react-router-dom'
import BG from './background.svg'

export default function Footer() {
  const history = useHistory()

  // const link2 = [
  //   {
  //     name: 'HOME',
  //     link: '#home',
  //   },
  //   {
  //     name: 'TOKENOMICS',
  //     link: '#tokonomics',
  //   },
  //   {
  //     name: 'ROADMAP',
  //     link: '#roadMap',
  //   },
  //   {
  //     name: 'TEAM',
  //     link: '#ourTeam',
  //   },
  //   {
  //     name: 'Use Cases',
  //     link: '#useCase',
  //   },
  //   {
  //     name: 'SOLAR',
  //     link: '#solar',
  //   },
  // ]
  const link2 = [
    {
      name: 'HOME',
      link: '#home',
    },
    {
      name: 'TOKENOMICS',
      link: '#tokonomics',
    },
    {
      name: 'ROADMAP',
      link: '#roadMap',
    },
    {
      name: 'TEAM',
      link: '#ourTeam',
    },
    {
      name: 'Use Cases',
      link: '#useCase',
    },
    {
      name: 'MEDIA',
      link: '#media',
    },
    {
      name: 'Partnership',
      link: '#partner',
    },
    {
      name: 'SOLAR',
      link: 'https://solscan.io/token/2wmKXX1xsxLfrvjEPrt2UHiqj8Gbzwxvffr9qmNjsw8g',
    },
  ]
  return (
    <>
      <Box mt={15} id="footer">
        <hr />
        <Box mb={5} px={5}>
          <Grid
            container
            sx={{
              textTransform: 'uppercase',
              color: 'white',
              letterSpace: '4px',
            }}
            justifyContent="space-between"
          >
            {link2.map((obj) => {
              return (
                <Grid
                  item
                  mt={2}
                  mr={2}
                  onClick={() => {
                    history.push('/')
                  }}
                >
                  {' '}
                  <a
                    href={obj.link}
                    style={{
                      fontSize: '12px',
                      fontWeight: '400px',
                      color: 'white',
                      textDecoration: 'none',
                    }}
                  >
                    {obj.name}
                  </a>{' '}
                </Grid>
              )
            })}
            <Grid item mt={2}>
              {' '}
              <Link
                to="/preSale"
                style={{
                  fontSize: '12px',
                  fontWeight: '400px',
                  color: 'white',
                  textDecoration: 'none',
                  padding: '5px 10px',
                }}
                className="glow-on-hover"
              >
                {' '}
                PreSale{' '}
              </Link>{' '}
            </Grid>
          </Grid>
        </Box>
        <img src={BG} alt={BG} width="100%" />
      </Box>
    </>
  )
}
